module.exports = __webpack_public_path__ + "static/fipcwhiteelephantmain-89928a2451990be628a2291b278c98b5.jpeg";